export class Api {

  constructor(token, url) {
    this.token = token;
    this.url = url;
  }

  doLogin(user, pass) {

    return fetch(`${this.url}/abogados/login`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({username: user, password: pass}),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error al intentar ingresar a la aplicación...");
        }
      })
  }

  getExpendientes(codAbogado) {

    return fetch(`${this.url}/abogados/${codAbogado.trim()}/expedientes`,
      {
        headers: {
          'Authorization': `Bearer ${this.token}`
        }
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('No se pudieron recuperar los expedientes....');
        }
      })
  }

  getTramites(idExpediente) {
    return fetch(`${this.url}/tramites/exp/${idExpediente.trim()}`,
    {
      headers: {
        'Authorization': `Bearer ${this.token}`
      }
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Error al recuperar los datos de la API REST...');
      }
    })
  }
 
  
  getTipoTramites() {
    return fetch(`${this.url}/tramites/tipotramites`,
    {
      headers: {
        'Authorization': `Bearer ${this.token}`
      }
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Error al recuperar los datos de la API REST...');
      }
    })
  }

  saveTramites(data) {
    return fetch(`${this.url}/tramites/`,
      {
      method:'PUT',
      headers: { 
        'Authorization': `Bearer ${this.token}`,
        'Accept':'application/json',
        'Content-type':'application/json'
      },
      body:JSON.stringify(data)
    })
  }

  saveGastos(data) {
    return fetch(`${this.url}/gastos/`,
      {
      method:'PUT',
      headers: { 
        'Authorization': `Bearer ${this.token}`,
        'Accept':'application/json',
        'Content-type':'application/json'
      },
      body:JSON.stringify(data)
    })
  }


  getTipoGastos(){
    return fetch(`${this.url}/gastos/tipogastos`,
        {
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Error al recuperar los datos de la API REST...');
          }
        })
  } 

  deleteGastos(idGasto) {
    //return fetch (API_GASTOS_DELETE + idGasto,
    console.log("deleteGastos");
    console.log(`${this.url}/gastos/${idGasto}`);
     
    return fetch(`${this.url}/gastos/${idGasto}`,
    {
      method:'DELETE',
      headers: {
        'Authorization': `Bearer ${this.token}`
      }
    })
  }

  deleteTramites(idExpediente) {
    console.log("deleteTramites");
    console.log(`${this.url}/tramites/${idExpediente}`);
     
    return fetch(`${this.url}/tramites/${idExpediente}`,
    {
      method:'DELETE',
      headers: {
        'Authorization': `Bearer ${this.token}`
      }
    })
  }

  getGastos(idGastos) {
    
    return fetch(`${this.url}/gastos/exp/${idGastos.trim()}`, 
    {
      headers: {
        'Authorization': `Bearer ${this.token}`
      }
    })
    .then(response=>  {
        if ( response.ok ) {
            return response.json();
        } else {
            throw new Error('Error al recuperar los datos de los gastos de la API REST...ID='+idGastos.trim());
        }
        })
      
  }        

}
